// extracted by mini-css-extract-plugin
module.exports = {"slider":"Slider_slider__24xEK"};